import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const variants = {
    default: 'bg-blue-50 text-blue-900 border-blue-200',
    destructive: 'bg-red-50 text-red-900 border-red-200',
};
export const Alert = React.forwardRef(({ className = '', variant = 'default', ...props }, ref) => {
    return (_jsx("div", { ref: ref, role: "alert", className: `relative w-full rounded-lg border p-4 ${variants[variant] || variants.default} ${className}`, ...props }));
});
Alert.displayName = 'Alert';
export const AlertDescription = React.forwardRef(({ className = '', ...props }, ref) => (_jsx("div", { ref: ref, className: `text-sm [&_p]:leading-relaxed ${className}`, ...props })));
AlertDescription.displayName = 'AlertDescription';
